'use strict';

import core from './core';
import settings from './settings';

export default {
  core,
  settings,
};
